import React, { useState, useEffect } from 'react';
import { list_banks } from '../../static/vars';
import { getDiscounts, addDiscount, deleteDiscount } from './personapi'; // Подставьте путь к функциям getDiscounts и addDiscount из вашего кода API
import './discounts.css';

export function Discounts() {
    const [discounts, setDiscounts] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBank, setSelectedBank] = useState('');
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [discountValue, setDiscountValue] = useState('');

    const companies = [
        { value: 1, name: 'Абсолют' },
        { value: 2, name: 'Зетта' },
        { value: 4, name: 'ВСК' }
    ]

    const types = [
        { value: 1, name: 'Имущество' },
        { value: 2, name: 'Жизнь' }
    ]

    useEffect(() => {
        // Запрос списка скидок при загрузке компонента
        fetchDiscounts();
    }, []);

    const fetchDiscounts = () => {
        getDiscounts({}, (data) => {
            console.log('getDiscounts', data);
            if (!data.error) setDiscounts(data);
        });
    };

    const handleAddDiscount = () => {
        setIsModalOpen(true);
    };

    const handleSaveDiscount = () => {
        // Проверка заполнения всех полей
        if (!selectedBank || !selectedCompany || !discountValue) {
            alert('Please fill in all fields');
            return;
        }

        // Отправка запроса на добавление новой скидки
        const newDiscount = {
            bank_id: selectedBank,
            company_id: selectedCompany,
            percent: discountValue,
            type: selectedType
        };

        addDiscount(newDiscount, (response) => {
            console.log('addDiscount response', response);
            if (!response.error) {
                fetchDiscounts(); // Обновление списка скидок после добавления новой
                setIsModalOpen(false); // Закрытие модального окна
            }
        });
    };

    function getBankName(bankId) {
        const bank = list_banks.find(bank => bank.value === bankId.toString());
        return bank ? bank.label : 'Неизвестный банк';
    }

    function getCompanyName(companyId) {
        const company = companies.find(company => company.value === companyId);
        return company ? company.name : 'Неизвестная компания';
    }

    const handleDeleteDiscount = (discountId) => {
        deleteDiscount({ discountId: discountId }, (response) => {
            console.log('deleteDiscount response', response);
            if (!response.error) {
                fetchDiscounts(); // Обновление списка скидок после удаления
            }
        });
    };


    return (
        <>
            <h4>Скидки</h4>

            <table>
                <thead>
                    <tr>
                        <th>Банк</th>
                        <th>Компания</th>
                        <th>Тип</th>
                        <th>% агента (по умолч. 30%)</th>
                        <th>Действия</th>
                    </tr>
                </thead>
                <tbody>
                    {discounts.map((discount, index) => (
                        <tr key={index}>
                            <td>{getBankName(discount.bank_id)}</td>
                            <td>{getCompanyName(discount.company_id)}</td>
                            <td>{discount.type === 'prop' ? 'Имущество' : "Жизнь"}</td>
                            <td>{discount.percent}</td>
                            <td>
                                <button className='btn_table_delete' onClick={() => handleDeleteDiscount(discount.id)}>Удалить</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button className='add-button' onClick={handleAddDiscount}>Добавить</button>

            {isModalOpen && (
                <div className='modal'>
                    <h4>Добавить скидку</h4>
                    <select onChange={(e) => setSelectedBank(e.target.value)}>
                        <option value="">Выберите банк</option>
                        {list_banks.map((bank) => (
                            <option key={bank.value} value={bank.value}>
                                {bank.label}
                            </option>
                        ))}
                    </select>
                    {selectedBank && (
                        <select onChange={(e) => setSelectedCompany(e.target.value)}>
                            {companies.map((company) => (
                                <option value={company.value}>{company.name}</option>
                            ))}
                        </select>
                    )}
                    {selectedCompany && (
                        <select onChange={(e) => setSelectedType(e.target.value)}>
                            {types.map((type) => (
                                <option value={type.value}>{type.name}</option>
                            ))}
                        </select>
                    )}
                    {selectedCompany && (
                        <input
                            type="number"
                            placeholder="Введите скидку"
                            value={discountValue}
                            onChange={(e) => setDiscountValue(e.target.value)}
                        />
                    )}
                    <button className='save-button' onClick={handleSaveDiscount}>Сохранить</button>
                </div>
            )}
        </>
    );
}
